import "../assets/css/videos.css";
import { useState, useEffect } from "react";
import { Loading } from "../components/loading";
import { MediaSlider } from "../components/mediaSlider";

export const Videos = ({ videos, isShowSectionTitle = true }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (videos && videos.length > 0) {
      setLoading(false);
    }
  }, [videos, isShowSectionTitle]);

  return (
    <section id="videos">
      {loading ? (
        <Loading />
      ) : (
        <div className="videos-container">
          {isShowSectionTitle && (
            <div>
              <h3>VIDEOS</h3>
              <hr />
            </div>
          )}
          <MediaSlider mediaList={videos} isAutoLoop={false} isVideo={true} />
        </div>
      )}
    </section>
  );
};
